
import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';
import { Reference } from '@sanity/types';
import {
  ISanityDocuments,
  SanityDocumentSchema,
  ProjectPageVariation,
} from '~/types/sanity-documents';
import SanityBlockContent from '~/components/Sanity/SanityBlockContent.vue';
import ProjectUpdate from './ProjectUpdate.vue';

interface IDocWithDate {
  data: ISanityDocuments[SanityDocumentSchema.ARTICLE];
  sortDate: number;
}

@Component({
  components: {
    ProjectUpdate,
    SanityBlockContent,
  },
})
export default class ProjectUpdatesTab extends Vue {
  @Prop(Boolean) readonly loading!: boolean;
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.PROJECT];

  schemas = SanityDocumentSchema;
  variations = ProjectPageVariation;

  get isLoadingUpdates() {
    return this.updateDocs?.every((state) => state?.isLoading) || false;
  }

  get updateDocs() {
    return (
      this.doc?.updates?.map((ref) => {
        const refState = this.$sanityLookup.getReference(ref);
        if (refState?.isLoading) {
          return {
            isLoading: true,
            hasError: false,
          };
        }
        return this.$sanityLookup.getDocument<
          ISanityDocuments[SanityDocumentSchema.ARTICLE]
        >({ _id: ref._ref, _type: this.schemas.ARTICLE });
      }) || []
    );
  }

  get updates() {
    const updatesWithDate: IDocWithDate[] = [];
    this.updateDocs?.forEach((state) => {
      if (state?.data) {
        const pubDate = new Date(
          state.data.publishedAt || state.data._createdAt,
        );
        updatesWithDate.push({
          data: state.data,
          sortDate: pubDate.getTime(),
        });
      }
    });
    updatesWithDate.sort((a, b) => b.sortDate - a.sortDate);
    return updatesWithDate;
  }

  get variation() {
    return this.$sanityLookup.getSiteConfig()?.data?.projectPageVariation;
  }

  @Watch('doc.updates', { immediate: true })
  handleUpdateRefsChange(current: Reference[] | undefined) {
    if (!current?.length) {
      return;
    }
    const refIds = current.map((ref) => ref._ref);
    this.$sanityLookup.fetchReference({
      _id: refIds,
      _type: this.schemas.ARTICLE,
    });
  }
}
